import { hasPermission } from "@/js/Rules"

export const requiredPermissionsForRoute = (route) =>
  (route?.matched ?? []).flatMap((record) => {
    const required = record.meta?.requiredPermission
    if (!required) return []
    return Array.isArray(required) ? required : [required]
  })

export const canNavigateToRoute = (route, user) =>
  requiredPermissionsForRoute(route).every((permission) => hasPermission(user, permission))
